import { useMemo } from 'react';
import { useEmailFieldsAsFilterableFields } from './custom-fields';

export const useEmailFieldsAsFilterableField = () => {
  const { fields: emailFields, loading: emailFieldsLoading } =
    useEmailFieldsAsFilterableFields();

  return useMemo(
    () => ({
      fields: emailFields,
      loading: emailFieldsLoading,
    }),
    [emailFields, emailFieldsLoading],
  );
};
